// Blog posts metadata.
// Add a new entry here when publishing a new post. The slug must match
// the .md filename in src/content/posts/ (without the extension).
// Posts are listed in reverse-chronological order (newest first).

export const posts = [
  {
    slug: "tracking-is-not-transparency",
    title: "Tracking is not transparency",
    date: "2026-05-31",
    excerpt:
      "Job application trackers help individual candidates organize their search. They don't reduce ghosting because ghosting isn't a tracking problem. It's a coordination failure between three parties.",
    readingTimeMinutes: 4,
  },
  {
    slug: "ai-cover-letter",
    title: "If AI Is Coming for Your Job, Why Use It to Get One?",
    date: "2026-06-03",
    excerpt:
      "Everyone is anxious that AI will take their job. So why are thousands of people using AI to write their cover letter? If AI can do your application, what does that say about what you bring?",
    readingTimeMinutes: 3,
  },
  {
    slug: "the-system-wasnt-built-for-her",
    title: "The System Wasn't Built for Her",
    date: "2026-06-10",
    excerpt:
      "A woman at a public library, printing job applications on paper to track 30 submissions. My wife saw her. The same week, my wife sent me a Stanford paper on algorithmic monoculture in hiring. The same system, seen from two different distances.",
    readingTimeMinutes: 3,
  },
  {
    slug: "package-tracking-for-hiring",
    title: "What Package Tracking for Hiring Actually Looks Like",
    date: "2026-06-23",
    excerpt:
      "When you order something online, you know exactly where it is. The package always knows where it is. The application doesn't. Here's what the alternative looks like.",
    readingTimeMinutes: 3,
  },
  {
    slug: "ai-assisted-development",
    title: "I Built Joborigo with AI. Here Is What That Actually Means.",
    date: "2026-07-24",
    excerpt:
      "Every time I post about Joborigo, someone calls it a vibe coding project. I am not embarrassed. But I think the criticism is aimed at the wrong target.",
    readingTimeMinutes: 4,
  },
  {
      slug: "three-sides-of-an-ugly-coin",
      title: "Three Sides of an Ugly Coin",
      date: "2026-09-03",
      excerpt:
        "I went looking for a way to fill the Joborigo arena faster. I found an industry selling 1.5 billion profiles of people who never agreed to be listed, and I want to describe what is actually on the market.",
      readingTimeMinutes: 5,
  },
  {
    slug: "feed-we-did-not-build",
    title: "The feed we didn't build",
    date: "2026-09-26",
    excerpt:
      "LinkedIn didn't set out to make people perform their careers. It became that anyway, because that's what any feed does once growth depends on engagement. Joborigo has no feed, no likes, no follower counts, not as an absence, but as a refusal.",
    readingTimeMinutes: 2,
  },
];

export function getPostBySlug(slug) {
  return posts.find((p) => p.slug === slug);
}
